<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '50rem', maxWidth: '90vw' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="!isSaving()">
  <ng-template #header>
    <div class="dialog-header">
      <span>{{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.TITLE' | translate }}</span>
    </div>
  </ng-template>
  <div class="twilio-config-form">
    <div class="config-section two-column">
      <div class="form-field">
        <label for="twilio-name">
          {{ 'SETTINGS_SMS.GATEWAY.NAME' | translate }}
          <span class="required">*</span>
        </label>
        <input
          pInputText
          id="twilio-name"
          type="text"
          [ngModel]="formModel().name"
          (ngModelChange)="updateField('name', $event)"
          class="w-full"
          [class.ng-invalid]="!!serverErrors.get('name')"
          [attr.aria-invalid]="!!serverErrors.get('name') || null"
          [attr.aria-describedby]="serverErrors.get('name') ? 'twilio-name-error' : null"
          required />
        @if (serverErrors.get('name')) {
          <small id="twilio-name-error" class="p-error" role="alert">
            {{ serverErrors.get('name') }}
          </small>
        }
      </div>
      <div class="form-field toggle-field">
        <span class="toggle-spacer" aria-hidden="true">&nbsp;</span>
        <div class="toggle-inline">
          <p-toggleSwitch
            id="twilio-enabled"
            [ngModel]="formModel().enabled"
            (ngModelChange)="updateField('enabled', $event)"
            [disabled]="isEditingSystem()" />
          <span class="toggle-label">{{ 'SETTINGS_SMS.GATEWAY.ENABLED' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- Basic Configuration Section -->
    <div class="config-section">
      <h3 class="section-header">{{ 'SETTINGS_SMS.GATEWAY.BASIC_CONFIGURATION' | translate }}</h3>
      <div class="form-fields">
        <div class="form-field">
          <label for="twilio-username">
            {{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.USERNAME' | translate }}
            <span class="required">*</span>
          </label>
          <input
            pInputText
            id="twilio-username"
            type="text"
            [ngModel]="formModel().username"
            (ngModelChange)="updateField('username', $event)"
            placeholder="{{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.ENTER_USERNAME' | translate }}"
            class="w-full"
            [disabled]="isEditingSystem()"
            [class.ng-invalid]="!!serverErrors.get('username')"
            [attr.aria-invalid]="!!serverErrors.get('username') || null"
            [attr.aria-describedby]="serverErrors.get('username') ? 'twilio-username-error' : null"
            required />
          @if (serverErrors.get('username')) {
            <small id="twilio-username-error" class="p-error" role="alert">
              {{ serverErrors.get('username') }}
            </small>
          }
        </div>
        <div class="form-field">
          <label for="twilio-account-sid">
            {{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.ACCOUNT_SID' | translate }}
            <span class="required">*</span>
          </label>
          <input
            pInputText
            id="twilio-account-sid"
            type="text"
            [ngModel]="formModel().accountSid"
            (ngModelChange)="updateField('accountSid', $event)"
            placeholder="{{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.ENTER_ACCOUNT_SID' | translate }}"
            class="w-full"
            [disabled]="isEditingSystem()"
            [class.ng-invalid]="!!serverErrors.get('accountSid')"
            [attr.aria-invalid]="!!serverErrors.get('accountSid') || null"
            [attr.aria-describedby]="serverErrors.get('accountSid') ? 'twilio-account-sid-error' : null"
            required />
          @if (serverErrors.get('accountSid')) {
            <small id="twilio-account-sid-error" class="p-error" role="alert">
              {{ serverErrors.get('accountSid') }}
            </small>
          }
        </div>
      </div>
    </div>

    <!-- Authentication Section -->
    <div class="config-section">
      <h3 class="section-header">
        {{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.AUTHENTICATION' | translate }}
      </h3>
      <div class="form-fields">
        <div class="form-field">
          <label for="twilio-auth-token">
            {{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.AUTH_TOKEN' | translate }}
            <span class="required">*</span>
          </label>
          <input
            pInputText
            id="twilio-auth-token"
            type="password"
            [ngModel]="formModel().authToken"
            (ngModelChange)="updateField('authToken', $event)"
            placeholder="{{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.ENTER_AUTH_TOKEN' | translate }}"
            class="w-full"
            [disabled]="isEditingSystem()"
            [class.ng-invalid]="!!serverErrors.get('authToken')"
            [attr.aria-invalid]="!!serverErrors.get('authToken') || null"
            [attr.aria-describedby]="serverErrors.get('authToken') ? 'twilio-auth-token-error' : null" />
          @if (serverErrors.get('authToken')) {
            <small id="twilio-auth-token-error" class="p-error" role="alert">
              {{ serverErrors.get('authToken') }}
            </small>
          }
        </div>
        <div class="form-field">
          <label for="twilio-account-auth-token">
            {{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.ACCOUNT_AUTH_TOKEN' | translate }}
            <span class="required">*</span>
          </label>
          <input
            pInputText
            id="twilio-account-auth-token"
            type="password"
            [ngModel]="formModel().accountAuthToken"
            (ngModelChange)="updateField('accountAuthToken', $event)"
            placeholder="{{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.ENTER_ACCOUNT_AUTH_TOKEN' | translate }}"
            class="w-full"
            [disabled]="isEditingSystem()"
            [class.ng-invalid]="!!serverErrors.get('accountAuthToken')"
            [attr.aria-invalid]="!!serverErrors.get('accountAuthToken') || null"
            [attr.aria-describedby]="serverErrors.get('accountAuthToken') ? 'twilio-account-auth-token-error' : null" />
          @if (serverErrors.get('accountAuthToken')) {
            <small id="twilio-account-auth-token-error" class="p-error" role="alert">
              {{ serverErrors.get('accountAuthToken') }}
            </small>
          }
        </div>
      </div>
    </div>

    <!-- Optional Configuration Section -->
    <div class="config-section">
      <h3 class="section-header">
        {{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.OPTIONAL_CONFIGURATION' | translate }}
      </h3>
      <div class="form-fields">
        <div class="form-field">
          <label for="twilio-message-service-sid">
            {{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.MESSAGE_SERVICE_SID' | translate }}
          </label>
          <input
            pInputText
            id="twilio-message-service-sid"
            type="text"
            [ngModel]="formModel().messagingServiceSid"
            (ngModelChange)="updateField('messagingServiceSid', $event)"
            placeholder="{{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.ENTER_MESSAGE_SERVICE_SID' | translate }}"
            class="w-full"
            [disabled]="isEditingSystem()"
            [class.ng-invalid]="!!serverErrors.get('messagingServiceSid')"
            [attr.aria-invalid]="!!serverErrors.get('messagingServiceSid') || null"
            [attr.aria-describedby]="serverErrors.get('messagingServiceSid') ? 'twilio-message-service-sid-error' : null" />
          @if (serverErrors.get('messagingServiceSid')) {
            <small id="twilio-message-service-sid-error" class="p-error" role="alert">
              {{ serverErrors.get('messagingServiceSid') }}
            </small>
          }
        </div>
        <div class="form-field">
          <label for="twilio-phone-number">
            {{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.PHONE_NUMBER' | translate }}
          </label>
          <input
            pInputText
            id="twilio-phone-number"
            type="text"
            [ngModel]="formModel().phoneNumber"
            (ngModelChange)="updateField('phoneNumber', $event)"
            placeholder="{{ 'SETTINGS_SMS.GATEWAY.TWILIO_CONFIGURATION.ENTER_PHONE_NUMBER' | translate }}"
            class="w-full"
            [disabled]="isEditingSystem()"
            [class.ng-invalid]="!!serverErrors.get('phoneNumber')"
            [attr.aria-invalid]="!!serverErrors.get('phoneNumber') || null"
            [attr.aria-describedby]="serverErrors.get('phoneNumber') ? 'twilio-phone-number-error' : null" />
          @if (serverErrors.get('phoneNumber')) {
            <small id="twilio-phone-number-error" class="p-error" role="alert">
              {{ serverErrors.get('phoneNumber') }}
            </small>
          }
        </div>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <p-button
      label="{{ 'GENERAL.CANCEL' | translate }}"
      severity="secondary"
      [outlined]="true"
      [disabled]="isSaving()"
      (onClick)="onCancel()" />
    <p-button
      label="{{ 'GENERAL.SAVE' | translate }}"
      severity="primary"
      [loading]="isSaving()"
      [disabled]="isSaving() || !isValid()"
      (onClick)="handleSave()" />
  </ng-template>
</p-dialog>
